import type { ReactNode } from 'react';
import type { Capability } from '../api/capabilities';
import { useCapabilities } from '../Capabilities';
import { PagePlaceholder } from '../pages/PagePlaceholder';

/**
 * A route that only renders when this instance can serve it.
 *
 * The sidebar already hid these pages, but every route stayed mounted, so a
 * link or a bookmark carried from another instance — `/graph` on wingd —
 * rendered the page and a cascade of 503s. The extension that serves the
 * page is the same one the sidebar names for it.
 *
 * Unknown capabilities render nothing, as the sidebar does, rather than
 * flashing the page or the notice.
 */
export function RequireCapability({
  capability,
  title,
  children,
}: {
  capability: Capability;
  title: string;
  children: ReactNode;
}) {
  const caps = useCapabilities();
  if (caps === null) return null;
  if (caps[capability] === true) return <>{children}</>;
  return (
    <PagePlaceholder
      title={title}
      subtitle={`Not on this instance: it does not enable ${capability}, which serves this page.`}
    />
  );
}
